<template>
    <div class="filter-bar">
        <h2 class="filter-bar-heading">Search Resources</h2>
        <div class="global-container">
            <button class="btn primary-btn js-toggle-filter-menu hide-desktop" type="button">Sort &amp; Filter <span class="icon-angle-down"></span></button>
            <aside class="side-menu resource-filter-menu js-filter-menu">
                <div class="row">
                    <filter-group v-for="(filter, key, index) in filters" v-bind:filter="filter" v-bind:key="key" v-bind:index="index"></filter-group>
                </div>
                <div class="row" v-if="secondaryfilters">
                    <filter-group v-for="(filter, key, index) in secondaryfilters" v-bind:filter="filter" v-bind:key="key" v-bind:index="index"></filter-group>
                </div>
            </aside>
        </div>
    </div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import FilterGroup from '../ui/filter-group';

	export default {
		props: ['filters', 'secondaryfilters'],
		data: function() {
			return  {
				query: '',
				pageSize: 5
			}
		},
		 computed: mapState({
			pagination: state => state.listing.pagination,
			specification: state => state.listing.specification,
		}),
		components: {
			'filter-group': FilterGroup,
		},
		mounted() {
			this.query = this.specification.SearchTerm;
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
			setSearchTerm() {
				this.updateSpecification({ key: 'SearchTerm', value: decodeURIComponent(this.query) });
			},
			setPageSize() {
				this.updateSpecification({ key: 'PageSize', value: this.pageSize });
			},
			filter() {
				this.setFilter();
			},
			resetFilter() {
				this.resetSpecification();
            }
        },

    }
</script>